var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDianpingRate = function SvgDianpingRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FE8F24",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.66 8c.795 0 1.458.56 1.533 1.275l.007.137v13.881c0 .261-.183.5-.475.623a1.13 1.13 0 0 1-.802.02l-.123-.055-2.086-1.091-1.277 1.002c-.179.136-.405.21-.637.207a1.1 1.1 0 0 1-.525-.132l-.112-.075L16 22.88l-1.163.913a1.09 1.09 0 0 1-1.173.069l-.1-.069-1.278-1.002-2.086 1.092a1.12 1.12 0 0 1-.925.034.74.74 0 0 1-.467-.527l-.008-.096V9.412c0-.729.611-1.337 1.393-1.405L10.34 8zm-.517 1.882H10.857v11.486l1.666-.87 1.677 1.314L16 20.4l1.799 1.412 1.677-1.314 1.666.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.355 17.226a1.13 1.13 0 1 1 0 2.258 1.13 1.13 0 0 1 0-2.258m-.665-4.242a.941.941 0 1 1 1.33 1.33l-4.705 4.706a.94.94 0 0 1-1.331 0 .94.94 0 0 1 0-1.33zm-4.04-.464a1.13 1.13 0 1 1 0 2.259 1.13 1.13 0 0 1 0-2.259"
  })))));
};
export default SvgDianpingRate;